// eslint-disable-next-line func-names
(function () {
// Manage JavaScript classes for Progressive Enhancement
    const body = document.querySelector('body');
    body.classList.remove('no-js');
    body.classList.add('has-js');
}());
